"use strict";

const IExecModule = require('./IExecModule');

const {
  show,
  obsTask,
  claim
} = require('../common/execution/task');

const {
  fetchTaskResults
} = require('../common/execution/result');

class IExecTaskModule extends IExecModule {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    this.show = async taskid => show(await this.config.resolveContractsClient(), taskid);

    this.obsTask = async function (taskid) {
      let {
        dealid
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return obsTask(await _this.config.resolveContractsClient(), taskid, {
        dealid
      });
    };

    this.claim = async taskid => claim(await this.config.resolveContractsClient(), taskid);

    this.fetchResults = async taskid => fetchTaskResults(await this.config.resolveContractsClient(), taskid, {
      ipfsGatewayURL: await this.config.resolveIpfsGatewayURL()
    });
  }

}

module.exports = IExecTaskModule;